// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import _ from 'lodash'
import moment from 'vue-moment'
import VueCurrencyFilter from 'vue-currency-filter'
import Vuebar from 'vuebar'
import VueResize from 'vue-resize'
import store from '@/store'
import { i18n, loadLanguageAsync } from '@/library/locale/i18n'
import config from '@/config'

Vue.filter('lowercase', function (value) {
  if (!value) return ''
  return value.toLowerCase()
})

Vue.prototype._ = _
Vue._ = _
Vue.use(VueResize)
Vue.use(moment)
Vue.use(Vuetify)
Vue.use(Vuebar)
Vue.use(VueCurrencyFilter, {
  symbol: (config.app.CURRENCY),
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

Vue.config.productionTip = false

// function hasQueryParams (route) {
//   return !!Object.keys(route.query).length
// }
//
// router.beforeEach((to, from, next) => {
//   if (!hasQueryParams(to) && hasQueryParams(from)) {
//     next({name: to.name, query: from.query})
//   } else {
//     next()
//   }
// })

/* eslint-disable no-new */

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>',
  created: function () {
    loadLanguageAsync()
  }
})



// WEBPACK FOOTER //
// ./src/main.js